import { render } from "./invest.vue?vue&type=template&id=6682ddd7"
import script from "./invest.js?vue&type=script&lang=js&external"
export * from "./invest.js?vue&type=script&lang=js&external"

import "./invest.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__